// @flow

// $FlowFixMe
const assign = require('object.assign');

import { getParamString } from "Shared/UrlParser/utils";
import { Events } from "utils/Events";
var routeParser = require('Shared/UrlParser/RouteParser.js');

export const STATE_ENUMS = {
    DEFAULT: 'default',
    ROUTE  : 'route',
}
export type KioskStateEnum = 'default' | 'route';

import type { LocationDescriptor } from "Shared/LocationDescriptor/LocationDescriptor";

export type KioskStateOptions = {
    state?: KioskStateEnum,
    campusid?: number,
    zoom?: number,
    bearing?: number,
    analytics?: boolean,
    start?: LocationDescriptor | null,
    dest? : LocationDescriptor | null,
    avoidStairs? : boolean,
};



export class KioskStateController{
    events: Events;
    state: KioskStateOptions;

    constructor ( state: KioskStateOptions ){
        this.events = new Events();
        this.state = state;
    }

    setState ( partial: KioskStateOptions ){
        this.state = assign({}, this.state, partial);
        this.trigger();
    }

    setFullState ( state: KioskStateOptions ){
        this.state = state;
        this.trigger();
    }

    getState (){
        return this.state;
    }

    trigger (){
        this.events.trigger('change', this.state);
    }

    setStart ( start: LocationDescriptor ){
        this.state.start = start;
        this.trigger();
    }

    getStart (){
        return this.state.start;
    }

    getDest (){
        return this.state.dest;
    }

    setDest ( dest: LocationDescriptor | null ){
        this.state.dest = dest;
        this.trigger();
    }

    setAvoidStairs ( avoidStairs: boolean ){
        this.state.avoidStairs = avoidStairs;
        this.trigger();
    }

    getAvoidStairs (): boolean {
        return this.state.avoidStairs ? true : false;
    }
}


/*
  Generate usable use.mazemap.com links based on the Kiosk state
  Example:
  - Kiosk shows a route from "you are here" to a poi
  - User uses the QR code on screen to get a link on the phone
  - Link opens in browser, and user navigates to poi
*/

export function generateKioskShareUrlFromState(stateparams: KioskStateOptions){
    let urlParameters = {
        v: 1
    };

    let baseurl = 'https://use.mazemap.com/';

    if( stateparams.campusid ){
        assign(urlParameters, {campusid: stateparams.campusid});
    }

    if( stateparams.start ){
        let startParams = routeParser.getRoutePointUrlParams('start', stateparams.start);
        assign(urlParameters, startParams);
    }

    if( stateparams.dest ){
        let destParams = routeParser.getRoutePointUrlParams('dest', stateparams.dest);
        assign(urlParameters, destParams);
    }

    if( stateparams.zoom ){
        assign(urlParameters, {zoom: stateparams.zoom});
    }

    if( stateparams.bearing ){
        assign(urlParameters, {bearing: stateparams.bearing});
    }

    if( stateparams.analytics !== false ){
        // Add Google Analytics tracking parameters
        assign(urlParameters, {
            utm_source: 'MazeMap Kiosk App',
            utm_medium: 'qrcode', // This is also used in webapp qr code links
        });
    }

    return baseurl + getParamString( urlParameters );
}



// WEBPACK FOOTER //
// src/kiosk/KioskState/index.js